(() => {
  const normalized = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
  class CCCaseProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-cc-variants]').textContent);
      this.form = this.querySelector('.cc-case-form');
      this.native = this.form.querySelector('[name="id"]');
      this.radios = [...this.querySelectorAll('.cc-picker input[type=radio]')];
      this.modelGroup = this.querySelector('[data-cc-model-group]') || this.querySelector('[data-cc-option]');
      this.modelIndex = Number(this.modelGroup?.dataset.ccOption || 0);
      this.finishGroup = this.querySelector('[data-cc-finish-group]');
      this.finishIndex = this.finishGroup ? Number(this.finishGroup.dataset.ccOption) : -1;
      this.selected = [];
      this.radios.forEach(input => { if (input.checked) this.selected[Number(input.dataset.index)] = input.value; });
      this.selected[this.modelIndex] = '';
      this.native.required = false;
      this.querySelector('.cc-no-js-picker').hidden = true;
      this.querySelector('.cc-js-picker').hidden = false;
      this.status = this.querySelector('[data-cc-picker-status]');
      this.button = this.querySelector('[data-cc-main-add]');
      this.error = this.querySelector('[data-cc-form-error]');
      this.buildGenerations();
      this.addEventListener('change', event => {
        if (event.target.matches('.cc-picker input')) {
          const input = event.target;
          this.selected[Number(input.dataset.index)] = input.value;
          if (Number(input.dataset.index) === this.modelIndex) {
            this.resolveFinish();
            this.saving = true; window.CCDevice?.set(input.value); this.saving = false;
          }
          this.sync(true);
        }
        if (event.target.matches('[data-cc-set-check]')) this.syncPayment();
      }, { signal: this.abort.signal });
      this.form.addEventListener('submit', event => this.submit(event), { signal: this.abort.signal });
      document.addEventListener('cc:device-change', event => {
        if (this.saving) return;
        this.selectDevice(event.detail.model);
      }, { signal: this.abort.signal });
      this.querySelector('[data-cc-picker-jump]')?.addEventListener('click', () => this.focusPicker());
      this.querySelector('[data-cc-sticky-submit]')?.addEventListener('click', () => this.form.requestSubmit());
      const explicit = this.variants.find(variant => String(variant.id) === this.dataset.initialVariant);
      if (explicit) { this.selected = [...explicit.options]; this.sync(); }
      else this.selectDevice(window.CCDevice?.get() || '');
      this.initializeGallery();
      this.dispatchEvent(new CustomEvent('cc:product-ready', {bubbles:true}));
    }
    disconnectedCallback() { this.abort?.abort(); this.galleryObserver?.disconnect(); this.initialized = false; }
    buildGenerations() {
      if (!this.modelGroup) return;
      this.models = this.radios.filter(input => Number(input.dataset.index) === this.modelIndex);
      const container = this.modelGroup.querySelector('[data-cc-picker-generations]');
      if (!container) return;
      const generations = [...new Set(this.models.map(input => input.value.match(/\d+/)?.[0] || 'SE'))].sort((a,b) => Number(b)-Number(a));
      container.replaceChildren();
      generations.forEach((generation,index) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'cc-chip'; button.textContent = generation; button.dataset.generation = generation;
        button.addEventListener('click', () => this.showGeneration(generation)); container.append(button);
        if (index === 0) this.showGeneration(generation);
      });
    }
    showGeneration(generation) {
      this.modelGroup.querySelectorAll('[data-generation]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.generation === generation)));
      this.models?.forEach(input => input.closest('label').hidden = (input.value.match(/\d+/)?.[0] || 'SE') !== generation);
    }
    selectDevice(model) {
      const match = this.models?.find(input => normalized(input.value) === normalized(model));
      this.selected[this.modelIndex] = match?.value || '';
      this.resolveFinish(); this.sync();
      if (model && !match) this.status.textContent = this.dataset.savedMissing;
    }
    resolveFinish() {
      if (this.finishIndex < 0 || !this.selected[this.modelIndex]) return;
      const matches = this.variants.filter(variant => variant.available && variant.options[this.modelIndex] === this.selected[this.modelIndex]);
      if (!matches.some(variant => variant.options[this.finishIndex] === this.selected[this.finishIndex])) {
        this.selected[this.finishIndex] = matches[0]?.options[this.finishIndex] || '';
      }
    }
    sync(updateUrl = false) {
      const model = this.selected[this.modelIndex];
      const variant = model ? this.variants.find(item => item.options.every((value,index) => value === this.selected[index])) : null;
      this.variant = variant;
      this.radios.forEach(input => {
        const index = Number(input.dataset.index);
        input.checked = input.value === this.selected[index];
        const available = this.variants.some(item => item.available && item.options[index] === input.value && (index === this.modelIndex || !model || item.options[this.modelIndex] === model));
        input.disabled = !available || (index !== this.modelIndex && !model);
        input.closest('label').classList.toggle('cc-option-unavailable', !available);
        input.closest('label').title = available ? '' : this.dataset.unavailable;
      });
      if (model) this.showGeneration(model.match(/\d+/)?.[0] || 'SE');
      this.native.value = variant?.id || '';
      this.native.dispatchEvent(new Event('change', {bubbles:true}));
      const label = !model ? this.dataset.choose : !variant?.available ? this.dataset.sold : `${this.dataset.add} · ${variant.money}`;
      this.querySelector('[data-cc-add-label]').textContent = label;
      this.button.setAttribute('aria-disabled', String(!variant?.available));
      this.status.textContent = '';
      if (model && this.finishIndex >= 0) {
        const available = [...new Set(this.variants.filter(item => item.available && item.options[this.modelIndex] === model).map(item => item.options[this.finishIndex]))];
        if (available.length === 1 && available[0].toLowerCase() === 'matte') this.status.textContent = this.dataset.matteOnly.replace('[model]',model);
      }
      if (model && !variant?.available) this.status.textContent = this.dataset.unavailable;
      if (variant) this.querySelector('[data-cc-price]').innerHTML = variant.priceHtml;
      if (variant?.image) {
        const hero = this.querySelector('[data-cc-variant-hero] img');
        const image = hero || this.querySelector('[data-cc-variant-image]');
        if (image) { image.removeAttribute('srcset'); image.src = variant.image; if (!hero) image.closest('[data-cc-variant-image-wrap]').hidden = false; }
      }
      this.syncPayment();
      const jump = this.querySelector('[data-cc-picker-jump]');
      if (jump) jump.textContent = model ? this.selected.filter(Boolean).join(' · ') : this.dataset.choose;
      const sticky = this.querySelector('[data-cc-sticky-submit]');
      if (sticky) { sticky.textContent = label; sticky.setAttribute('aria-disabled',String(!variant?.available)); }
      if (updateUrl && this.dataset.quick !== 'true' && variant) { const url = new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url); }
      this.dispatchEvent(new CustomEvent('cc:variant-change', {bubbles:true,detail:{variant}}));
    }
    syncPayment() {
      this.querySelector('[data-cc-payment]').hidden = !this.variant?.available || !!this.querySelector('[data-cc-set-check]:checked');
    }
    focusPicker() {
      const picker = this.querySelector('.cc-picker');
      picker.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});picker.focus({preventScroll:true});
      picker.classList.remove('cc-picker-nudge'); void picker.offsetWidth;picker.classList.add('cc-picker-nudge');
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      if (!this.variant?.available) { this.focusPicker();return; }
      const items = [{ id:this.variant.id,quantity:1 }];
      for (const checkbox of this.querySelectorAll('[data-cc-set-check]:checked')) {
        const choice = checkbox.closest('[data-cc-set-item]').querySelector('[data-cc-set-variant]');
        if (!choice.value) { choice.setCustomValidity(this.dataset.choose);choice.reportValidity();choice.focus();return; }
        choice.setCustomValidity('');items.push({id:Number(choice.value),quantity:1});
      }
      this.busy = true;this.button.disabled = true;this.button.setAttribute('aria-busy','true');this.error.hidden = true;
      try { await window.CCCart.add(items,this.button); }
      catch(error) { this.error.textContent = error.message || this.dataset.error;this.error.hidden = false; }
      finally { this.busy = false;this.button.disabled = false;this.button.removeAttribute('aria-busy'); }
    }
    initializeGallery() {
      const gallery = this.querySelector('[data-cc-gallery]');if (!gallery) return;
      const rail = gallery.querySelector('.cc-case-media');const thumbs = gallery.querySelector('[data-cc-thumbnails]');
      const slides = [...rail.children].filter(slide => !slide.hasAttribute('data-cc-variant-image-wrap'));
      slides.forEach((slide,index) => { const image = slide.querySelector('img,video');if (!image) return;const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`${window.ccStrings.media} ${index+1}`);const thumb=document.createElement('img');thumb.src=image.poster || image.currentSrc || image.src;thumb.alt='';thumb.width=48;thumb.height=60;button.append(thumb);button.addEventListener('click',()=>rail.scrollTo({left:slide.offsetLeft-rail.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));thumbs.append(button); });
      const update = () => { const max=rail.scrollWidth-rail.clientWidth;gallery.querySelector('[data-cc-gallery-progress]').style.width=`${max>0 ? 15+85*rail.scrollLeft/max:100}%`; };
      rail.addEventListener('scroll',update,{passive:true,signal:this.abort.signal});update();
    }
  }
  if (!customElements.get('cc-case-product')) customElements.define('cc-case-product',CCCaseProduct);
  document.addEventListener('click', async event => {
    const trigger=event.target.closest('[data-cc-quick]');if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    let dialog=document.getElementById('CCQuickDialog');
    if (!dialog) { dialog=document.createElement('dialog');dialog.id='CCQuickDialog';dialog.className='cc-dialog cc-quick-dialog';dialog.setAttribute('aria-label',window.ccStrings.choose);document.body.append(dialog); }
    dialog.ccController?.abort(); dialog.ccController = new AbortController();
    const controller = dialog.ccController;
    dialog.replaceChildren();
    const close=document.createElement('button');close.type='button';close.className='cc-dialog-close';close.dataset.ccDialogClose='';close.textContent=window.ccStrings.close;dialog.append(close);
    const content=document.createElement('div');content.textContent=window.ccStrings.loading;dialog.append(content);dialog.showModal();
    try { const url=new URL(trigger.dataset.ccQuick,location.origin);url.searchParams.set('section_id','cc-quick-product');const response=await fetch(url,{signal:controller.signal});if(!response.ok) throw new Error();const doc=new DOMParser().parseFromString(await response.text(),'text/html');const product=doc.querySelector('cc-case-product');if(!product) throw new Error();content.replaceChildren(product); }
    catch (error) { if(error.name==='AbortError') return; content.textContent=window.ccStrings.error;const link=document.createElement('a');link.href=trigger.href;link.textContent=window.ccStrings.choose;content.append(link); }
    dialog.addEventListener('close',()=>{controller.abort();trigger.focus();},{once:true});
  });
})();
